import { Link } from "react-router-dom";
import type { ReactNode } from "react";

import { useLocalePath } from "../../hooks/useLocalePath";
import { MATCH_SCHEDULE_COUNT } from "../../constants/constants";
import type { MatchScheduleItemData, MatchScheduleMode } from "../../types/match-schedule";
import { MatchScheduleList } from "../shared/MatchSchedule";

interface HomeMatchSectionProps {
  title: string;
  matches: MatchScheduleItemData[] | undefined;
  mode: MatchScheduleMode;
  scheduleLinkLabel?: string;
  scheduleLinkTo?: string;
  emptyContent?: ReactNode;
}

export const HomeMatchSection = ({
  title,
  matches,
  mode,
  scheduleLinkLabel,
  scheduleLinkTo = "/schedule",
  emptyContent,
}: HomeMatchSectionProps) => {
  const { localized } = useLocalePath();
  const games = matches?.slice(0, MATCH_SCHEDULE_COUNT);
  const hasGames = !!games?.length;

  const isLoading = matches === undefined;

  return (
    <section className="home-match-section">
      <h2 className="home-section-title">{title}</h2>

      <div className="home-match-list-slot">
        {isLoading ? (
          <ul className="schedule-list h-full max-md:h-auto" aria-hidden="true">
            {Array.from({ length: MATCH_SCHEDULE_COUNT }, (_, i) => (
              <li
                key={i}
                className="match-card animate-pulse border-white/[0.04] bg-white/[0.03]"
              />
            ))}
          </ul>
        ) : hasGames ? (
          <MatchScheduleList
            matches={games}
            mode={mode}
            className="schedule-list h-full max-md:h-auto"
          />
        ) : (
          emptyContent
        )}
      </div>

      {scheduleLinkLabel ? (
        <Link to={localized(scheduleLinkTo)} className="home-match-section-link">
          {scheduleLinkLabel}
        </Link>
      ) : null}
    </section>
  );
};
